import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import client from "../lib/api/client";
import {withRouter} from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import {useRecoilValue} from "recoil";
import {userState} from "../state/globalState";


const useStyles = makeStyles(theme => ({
    root: {
        height: "100%",
        width: "100%",
        margin: "30px 0"
    },
    title: {
        fontSize: "17px",
        fontWeight: "bold"
    },
    label: {
        fontSize: "14px",
        fontWeight: "bold",
        marginRight: "15px",
        textAlign: "center"
    },
    crtby: {
        fontSize: "14px",
        marginRight: "20px",
        textAlign: "center"
    },
    wtireButton: {
        display: "flex",
        width: "100%",
        justifyContent: "flex-end",
        marginTop: "10px",
        gap: "10px"
    },
    box: {
        margin: "20px 0"
    },
    headerWrapper: {
        margin: "20px 0",
        display: "flex",
        alignItems: "center"
    },
    divider: {
        margin: "30px 0",
        height: "2px",
        backgroundColor: "#333333"
    }
}));

const ResultMailForm = ({ setViewState, brdNo, setReTitle, history }) => {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const classes = useStyles();
    const userInfo = useRecoilValue(userState);
    const {stdYear, admnNo} = userInfo;

    useEffect(() => {
        // client.get(`/kognr/board/${brdNo}`, {cache: false}).then(response => {
        //     // const data = window.atob(response.data.payload.content);
        //     // const decoded = decodeURIComponent(data);
        //
        //     const { board, answerData } = response.data.payload;
        //     const { content, title, crtDate, crtby } = board;
        //
        //     setTitle(title);
        //     setContent(content);
        //     setCrtDt(crtDate);
        //     setcrtby(crtby);
        //
        //     if (answerData.ansNo) {
        //         const { answer, crtby, crtDate } = answerData;
        //         // const decoded = decodeURIComponent(data);
        //
        //         setAnswer(answer);
        //         setAnswerBy(crtby);
        //         setAnswerDt(crtDate);
        //     }
        //
        // }).catch((error) => {
        //     console.log(error);
        // });

        client.get('/kognr/resultMainCont', {
            params: {
                stdYear,
                admnNo
            }
        }).then(response => {
            const { mailCont } = response.data.payload;

            let replaceValue = mailCont.replace("<p style=\"font-weight: bolder; font-style: italic\">\"해당 이메일은 발신전용 메일입니다.\"</p>", "")

            if (process.env.NODE_ENV === "production") {
              replaceValue =  replaceValue.replace("https://eytax-uat.ey.com", "https://eytax.ey.com")
            }

            if(mailCont){
                setContent(replaceValue);
            }

        }).catch((error) => {
            console.log(error);
        });
    }, []);

    const handleModifyClick = () => {
        setViewState("WRITE");
        history.push(`/question/${brdNo}`);
    }

    const handleReQuestionClick = () => {
        setViewState("WRITE");
        setReTitle("[재질문] " + title);
        history.push(`/questions`);
    }

    const handleListClick = () => {
        setViewState("LIST");
        history.push("/questions");
    }

    return (
        <Grid container
              direction="column"
              alignItems="flex-start"
              justifyContent="center"
        >
            <div className={classes.root}>
                <div className="title-head">
                    <span>제출 결과</span>
                </div>
                <div className={classes.box}>
                    <span className={classes.title}>{title}</span>
                </div>

                <div className={classes.box}>
                    <div className="fr-wrapper">
                        <div className="fr-element fr-view" dangerouslySetInnerHTML={ {__html: content} }>
                        </div>
                    </div>
                </div>
                <Divider className={classes.divider} />
                {/*<div className={classes.wtireButton}>*/}
                {/*    <Button variant="outlined" size="small" color="primary" onClick={handleListClick}>*/}
                {/*        제출 결과 오류 문의*/}
                {/*    </Button>*/}
                {/*    <Button variant="contained" size="small" color="primary" onClick={handleModifyClick}>*/}
                {/*        메일 재발송*/}
                {/*    </Button>*/}
                {/*</div>*/}
            </div>
        </Grid>
    );
};
export default withRouter(ResultMailForm);

